export type TransmisionStatus = 'online' | 'offline' | 'reconectando' | 'pausado';

export type MensajeType = 'mensaje' | 'saludo' | 'cancion' | 'concurso' | 'voz';

export type MensajeEstado = 'nuevo' | 'leido' | 'respondido' | 'destacado' | 'bloqueado' | 'pendiente';

export type AccionTipo = 'responder' | 'destacar' | 'bloquear' | 'mover_al_aire' | 'seleccionar_ganador';

export type EncuestaEstado = 'activa' | 'cerrada' | 'programada';

export type ConcursoEstado = 'activo' | 'proximamente' | 'finalizado';

export interface LocutorInfo {
  nombre: string;
  avatar: string;
  rol: string;
  enVivo: boolean;
  programaActual: string;
  desde: string;
}

export interface ProgramaInfo {
  nombre: string;
  tipo: string;
  horario: string;
  progreso: number;
  duracionTotal: string;
  tiempoRestante: string;
}

export interface TransmisionInfo {
  status: TransmisionStatus;
  streamUrl: string;
  formato: string;
  bitrate: number;
  uptime: string;
  inicioUltima: string;
  proveedor: string;
}

export interface OyentesInfo {
  actuales: number;
  picoHoy: number;
  tendencia: 'up' | 'down' | 'stable';
  porcentaje: string;
  enCabina: number;
  escuchando: number;
}

export interface MensajeCentro {
  id: number;
  tipo: MensajeType;
  remitente: string;
  avatar: string;
  contenido: string;
  timestamp: string;
  estado: MensajeEstado;
  cancionSolicitada?: string;
  respuestaConcurso?: string;
  duracionVoz?: string;
  destacado: boolean;
  bloqueado: boolean;
  ubicacion: string;
}

export interface EncuestaCentro {
  id: number;
  pregunta: string;
  opciones: { texto: string; votos: number; porcentaje: number }[];
  totalVotos: number;
  estado: EncuestaEstado;
  creada: string;
  cierra: string;
  activa: boolean;
}

export interface ConcursoCentro {
  id: number;
  titulo: string;
  premio: string;
  participantes: number;
  respuestasCorrectas: number;
  estado: ConcursoEstado;
  ganador?: string;
  ganadorAvatar?: string;
  cierra: string;
}

export interface AccionConfig {
  tipo: AccionTipo;
  label: string;
  icono: string;
  gradiente: string;
  descripcion: string;
  shortcut: string;
}

export interface VistaRapida {
  id: string;
  label: string;
  icono: string;
  badge?: number;
}

export const transmisionStatusMeta: Record<TransmisionStatus, { label: string; dot: string; bg: string; text: string; pulso: boolean }> = {
  online: { label: 'En Vivo', dot: 'bg-emerald-500', bg: 'bg-emerald-100', text: 'text-emerald-700', pulso: true },
  offline: { label: 'Offline', dot: 'bg-foreground-400', bg: 'bg-foreground-100', text: 'text-foreground-600', pulso: false },
  reconectando: { label: 'Reconectando', dot: 'bg-amber-500', bg: 'bg-amber-100', text: 'text-amber-700', pulso: true },
  pausado: { label: 'Pausado', dot: 'bg-orange-500', bg: 'bg-orange-100', text: 'text-orange-700', pulso: false },
};

export const locutorActual: LocutorInfo = {
  nombre: 'Carlos Mendoza',
  avatar: 'https://readdy.ai/api/search-image?query=Professional%20Latino%20male%20radio%20host%20portrait%2C%20confident%20warm%20smile%2C%20casual%20modern%20style%2C%20broadcast%20studio%20environment%20with%20warm%20ambient%20lighting%2C%20clean%20professional%20headshot%2C%20friendly%20approachable%20expression%2C%20high%20detail%20editorial%20portrait%20photography&width=120&height=120&seq=centro-tx-locutor&orientation=squarish',
  rol: 'Locutor Principal',
  enVivo: true,
  programaActual: 'Tardes de Pop',
  desde: '2026-06-08T14:00:00',
};

export const programaActual: ProgramaInfo = {
  nombre: 'Tardes de Pop',
  tipo: 'Música y Entretenimiento',
  horario: '14:00 - 18:00',
  progreso: 62,
  duracionTotal: '4h 00m',
  tiempoRestante: '1h 31m',
};

export const transmisionActual: TransmisionInfo = {
  status: 'online',
  streamUrl: 'https://stream.radiofrecuenciaweb.com/live',
  formato: 'MP3',
  bitrate: 192,
  uptime: '3h 24m',
  inicioUltima: '2026-06-21T14:05:00',
  proveedor: 'Icecast',
};

export const oyentesActuales: OyentesInfo = {
  actuales: 1247,
  picoHoy: 1689,
  tendencia: 'up',
  porcentaje: '+8.4%',
  enCabina: 87,
  escuchando: 1160,
};

export const mensajes: MensajeCentro[] = [
  {
    id: 1,
    tipo: 'saludo',
    remitente: 'María Fernanda López',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20light%20background%2C%20casual%20style%2C%20professional%20headshot%20photography&width=80&height=80&seq=ctx-msg-1&orientation=squarish',
    contenido: 'Buenas tardes! Quiero mandar un saludo enorme a toda la gente de San José que nos escucha. Especialmente a mi familia en el barrio El Carmen. ¡Son los mejores!',
    timestamp: '2026-06-21T17:28:00',
    estado: 'nuevo',
    destacado: false,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 2,
    tipo: 'cancion',
    remitente: 'Pedro Gutiérrez',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background%2C%20gentle%20friendly%20face%2C%20professional%20headshot&width=80&height=80&seq=ctx-msg-2&orientation=squarish',
    contenido: 'Para nuestro aniversario 25, ¿podrían poner "Perfect" de Ed Sheeran? Esta canción significa mucho para mi esposa y para mí. Gracias por acompañarnos todos estos años.',
    timestamp: '2026-06-21T17:22:00',
    estado: 'nuevo',
    cancionSolicitada: 'Perfect — Ed Sheeran',
    destacado: true,
    bloqueado: false,
    ubicacion: 'Alajuela',
  },
  {
    id: 3,
    tipo: 'concurso',
    remitente: 'Andrea Torres',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%2C%20everyday%20casual%20look%2C%20soft%20daylight%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20light%20background%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=ctx-msg-3&orientation=squarish',
    contenido: 'Concurso Summer Fest: la respuesta es "Los Ecos" — la banda que abrió el festival del año pasado con ese tema increíble que todos coreamos.',
    timestamp: '2026-06-21T17:18:00',
    estado: 'nuevo',
    respuestaConcurso: 'Los Ecos',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Cartago',
  },
  {
    id: 4,
    tipo: 'voz',
    remitente: 'Lucía Mendoza',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=ctx-msg-4&orientation=squarish',
    contenido: 'Mensaje de voz — 0:42',
    timestamp: '2026-06-21T17:15:00',
    estado: 'nuevo',
    duracionVoz: '0:42',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Heredia',
  },
  {
    id: 5,
    tipo: 'mensaje',
    remitente: 'Diego Vargas',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=ctx-msg-5&orientation=squarish',
    contenido: 'Carlos, amé la entrevista que hicieron a Los Ecos el jueves. Pregúntenles si van a sacar nuevo álbum este año. ¡Necesito más música de ellos!',
    timestamp: '2026-06-21T17:10:00',
    estado: 'respondido',
    destacado: false,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 6,
    tipo: 'saludo',
    remitente: 'Sofía Hernández',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background%2C%20fashion%20portrait%20photography&width=80&height=80&seq=ctx-msg-6&orientation=squarish',
    contenido: 'Buenas! Saludos para todo el equipo de Tardes de Pop. Carlos, sos el mejor locutor del país. Nos alegrás las tardes a todos. ¡Seguí así!',
    timestamp: '2026-06-21T17:05:00',
    estado: 'destacado',
    destacado: true,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 7,
    tipo: 'cancion',
    remitente: 'Ana Patricia Vega',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background%2C%20professional%20yet%20approachable%2C%20editorial%20portrait&width=80&height=80&seq=ctx-msg-7&orientation=squarish',
    contenido: 'Para la hora del café: "Ojalá" de Silvio Rodríguez. Es una canción que me conecta con mis raíces y siempre me hace reflexionar. Gracias infinitas.',
    timestamp: '2026-06-21T16:55:00',
    estado: 'respondido',
    cancionSolicitada: 'Ojalá — Silvio Rodríguez',
    destacado: false,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 8,
    tipo: 'concurso',
    remitente: 'Roberto Sánchez',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background%2C%20everyday%20professional%20look&width=80&height=80&seq=ctx-msg-8&orientation=squarish',
    contenido: '12 bandas tocaron en el Parque Central durante las 3 noches del festival. ¡Fue épico! Ojalá repitan este año.',
    timestamp: '2026-06-21T16:48:00',
    estado: 'nuevo',
    respuestaConcurso: '12 bandas',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Cartago',
  },
  {
    id: 9,
    tipo: 'mensaje',
    remitente: 'Valentina Castro',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background%2C%20bohemian%20aesthetic%20portrait&width=80&height=80&seq=ctx-msg-9&orientation=squarish',
    contenido: 'Propongo que hagan un segmento de covers acústicos los viernes. La comunidad vota la canción y Carlos la canta con guitarra. Se llamaría "Viernes de Acústico".',
    timestamp: '2026-06-21T16:40:00',
    estado: 'destacado',
    destacado: true,
    bloqueado: false,
    ubicacion: 'Heredia',
  },
  {
    id: 10,
    tipo: 'saludo',
    remitente: 'Tomás Blanco',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20European%20Latino%20mixed%20man%2C%20creative%20style%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20clean%20background%2C%20casual%20modern%20look&width=80&height=80&seq=ctx-msg-10&orientation=squarish',
    contenido: 'Desde Alajuela mandando un abrazo a todos los escuchas. Manejar de vuelta a casa es mucho más llevadero con Tardes de Pop. ¡Temazos los de hoy!',
    timestamp: '2026-06-21T16:35:00',
    estado: 'leido',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Alajuela',
  },
  {
    id: 11,
    tipo: 'mensaje',
    remitente: 'Gabriela Mora',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%2C%20business%20casual%2C%20confident%20smile%2C%20soft%20studio%20light%2C%20clean%20background%2C%20corporate%20portrait%20style&width=80&height=80&seq=ctx-msg-11&orientation=squarish',
    contenido: 'Hola Carlos! Soy organizadora de eventos y me encantaría saber si hacen transmisiones para eventos privados. Tenemos una feria empresarial en agosto.',
    timestamp: '2026-06-21T16:28:00',
    estado: 'pendiente',
    destacado: false,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 12,
    tipo: 'cancion',
    remitente: 'Isabel Ramírez',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20teen%20Latina%20girl%2C%20bright%20cheerful%20expression%2C%20casual%20style%2C%20colorful%20background%2C%20natural%20light%2C%20happy%20youthful%20portrait&width=80&height=80&seq=ctx-msg-12&orientation=squarish',
    contenido: 'Holaaa! Para dedicar a mi mejor amiga que está de cumple: "Flowers" de Miley Cyrus. Es nuestro himno desde que salió. ¡Las amo!',
    timestamp: '2026-06-21T16:20:00',
    estado: 'nuevo',
    cancionSolicitada: 'Flowers — Miley Cyrus',
    destacado: false,
    bloqueado: false,
    ubicacion: 'San José',
  },
  {
    id: 13,
    tipo: 'voz',
    remitente: 'Martín Rojas',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20urban%20casual%20style%2C%20confident%20expression%2C%20modern%20lighting%2C%20clean%20background%2C%20street%20style%20portrait&width=80&height=80&seq=ctx-msg-13&orientation=squarish',
    contenido: 'Mensaje de voz — 1:15',
    timestamp: '2026-06-21T16:12:00',
    estado: 'leido',
    duracionVoz: '1:15',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Cartago',
  },
  {
    id: 14,
    tipo: 'concurso',
    remitente: 'Javier Núñez',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background%2C%20modern%20casual%20fashion&width=80&height=80&seq=ctx-msg-14&orientation=squarish',
    contenido: '3 días duró el festival: viernes, sábado y domingo con más de 15,000 asistentes. ¡Qué locura fue!',
    timestamp: '2026-06-21T16:05:00',
    estado: 'nuevo',
    respuestaConcurso: '3 días',
    destacado: false,
    bloqueado: false,
    ubicacion: 'Heredia',
  },
  {
    id: 15,
    tipo: 'mensaje',
    remitente: 'SpamBot_2024',
    avatar: 'https://readdy.ai/api/search-image?query=Generic%20default%20avatar%20placeholder%2C%20plain%20simple%20icon%20style%2C%20neutral%20expression%2C%20clean%20minimal%20background%2C%20basic%20user%20profile%20picture&width=80&height=80&seq=ctx-msg-15&orientation=squarish',
    contenido: '¡¡¡OFERTA LIMITADA!!! Compra ahora nuestro producto milagroso. 50% descuento. Visita el enlace. ¡No te lo pierdas!',
    timestamp: '2026-06-21T15:55:00',
    estado: 'bloqueado',
    destacado: false,
    bloqueado: true,
    ubicacion: '—',
  },
];

export const encuestas: EncuestaCentro[] = [
  {
    id: 1,
    pregunta: '¿Cuál debería ser el tema del próximo Viernes de Fiesta?',
    opciones: [
      { texto: 'Éxitos de los 90s', votos: 342, porcentaje: 38 },
      { texto: 'Electrónica Latina', votos: 287, porcentaje: 32 },
      { texto: 'Rock en Español', votos: 156, porcentaje: 17 },
      { texto: 'Covers Acústicos', votos: 118, porcentaje: 13 },
    ],
    totalVotos: 903,
    estado: 'activa',
    creada: '2026-06-21T14:30:00',
    cierra: '2026-06-21T20:00:00',
    activa: true,
  },
  {
    id: 2,
    pregunta: '¿A quién preferís como co-host invitado del mes?',
    opciones: [
      { texto: 'Diego Ramírez', votos: 412, porcentaje: 45 },
      { texto: 'Natalia Ruiz', votos: 298, porcentaje: 32 },
      { texto: 'Mariana Vega', votos: 211, porcentaje: 23 },
    ],
    totalVotos: 921,
    estado: 'activa',
    creada: '2026-06-20T10:00:00',
    cierra: '2026-06-25T18:00:00',
    activa: true,
  },
  {
    id: 3,
    pregunta: '¿Qué artista nuevo deberíamos entrevistar primero?',
    opciones: [
      { texto: 'Luna Azul (Indie)', votos: 267, porcentaje: 35 },
      { texto: 'DJ Phantom (Electrónica)', votos: 234, porcentaje: 31 },
      { texto: 'Los Urbanos (Reggaetón)', votos: 189, porcentaje: 25 },
      { texto: 'Voz del Alma (Balada)', votos: 68, porcentaje: 9 },
    ],
    totalVotos: 758,
    estado: 'cerrada',
    creada: '2026-06-18T09:00:00',
    cierra: '2026-06-20T18:00:00',
    activa: false,
  },
];

export const concursos: ConcursoCentro[] = [
  {
    id: 1,
    titulo: 'Gana Meet & Greet con Los Ecos',
    premio: 'Meet & Greet + Merch oficial',
    participantes: 847,
    respuestasCorrectas: 523,
    estado: 'activo',
    cierra: '2026-06-22T18:00:00',
  },
  {
    id: 2,
    titulo: 'Trivia Matutina: Adiviná la Canción',
    premio: 'Tarjeta de regalo de $50',
    participantes: 234,
    respuestasCorrectas: 178,
    estado: 'activo',
    cierra: '2026-06-22T10:00:00',
  },
  {
    id: 3,
    titulo: 'Sorteo del Código Secreto',
    premio: '$100 en efectivo',
    participantes: 1256,
    respuestasCorrectas: 0,
    estado: 'finalizado',
    ganador: 'Lucía Fernández',
    ganadorAvatar: 'https://readdy.ai/api/search-image?query=Happy%20young%20Hispanic%20woman%20portrait%2C%20warm%20genuine%20smile%2C%20casual%20modern%20outfit%2C%20natural%20light%2C%20soft%20bokeh%20background%2C%20candid%20lifestyle%20portrait%20photography&width=80&height=80&seq=ctx-ganador-1&orientation=squarish',
    cierra: '2026-06-20T18:00:00',
  },
];

export const accionesConfig: AccionConfig[] = [
  {
    tipo: 'responder',
    label: 'Responder',
    icono: 'ri-reply-line',
    gradiente: 'from-emerald-500 to-teal-500',
    descripcion: 'Responder al mensaje seleccionado',
    shortcut: 'R',
  },
  {
    tipo: 'destacar',
    label: 'Destacar',
    icono: 'ri-star-line',
    gradiente: 'from-amber-500 to-orange-500',
    descripcion: 'Destacar mensaje en el muro de la cabina',
    shortcut: 'D',
  },
  {
    tipo: 'bloquear',
    label: 'Bloquear',
    icono: 'ri-forbid-2-line',
    gradiente: 'from-rose-500 to-red-500',
    descripcion: 'Bloquear usuario y ocultar mensaje',
    shortcut: 'B',
  },
  {
    tipo: 'mover_al_aire',
    label: 'Mover al Aire',
    icono: 'ri-broadcast-line',
    gradiente: 'from-violet-500 to-fuchsia-500',
    descripcion: 'Leer mensaje o saludo en vivo al aire',
    shortcut: 'M',
  },
  {
    tipo: 'seleccionar_ganador',
    label: 'Seleccionar Ganador',
    icono: 'ri-trophy-line',
    gradiente: 'from-amber-500 to-yellow-500',
    descripcion: 'Elegir ganador del concurso activo',
    shortcut: 'G',
  },
];

export const vistasRapidas: VistaRapida[] = [
  { id: 'todo', label: 'Todo', icono: 'ri-dashboard-line' },
  { id: 'mensajes', label: 'Mensajes', icono: 'ri-chat-3-line', badge: 8 },
  { id: 'saludos', label: 'Saludos', icono: 'ri-user-heart-line', badge: 3 },
  { id: 'canciones', label: 'Canciones', icono: 'ri-music-line', badge: 3 },
  { id: 'encuestas', label: 'Encuestas', icono: 'ri-bar-chart-line', badge: 2 },
  { id: 'concursos', label: 'Concursos', icono: 'ri-trophy-line', badge: 2 },
  { id: 'bloqueados', label: 'Bloqueados', icono: 'ri-shield-line', badge: 1 },
];

export const statsCentro = {
  totalMensajes: 15,
  nuevosSinLeer: 6,
  enColaTransmision: 3,
  proximoAlAire: 'Perfect — Ed Sheeran',
  tiempoPromedioRespuesta: '3m 12s',
  satisfaccionOyente: '94.8%',
};

export const reglasCentro = [
  {
    id: 1,
    titulo: 'La Cabina debe ser el centro operativo principal',
    descripcion: 'Toda la operación diaria de la radio se controla desde esta pantalla. Transmisión, interacción con oyentes, concursos y contenido se gestionan sin necesidad de navegar a otras secciones.',
    icono: 'ri-focus-3-line',
    color: 'from-emerald-500 to-teal-500',
  },
  {
    id: 2,
    titulo: 'Responder en menos de 5 minutos',
    descripcion: 'Los mensajes de los oyentes merecen respuesta rápida. El centro muestra los mensajes nuevos primero y permite responder, destacar o mover al aire en segundos.',
    icono: 'ri-timer-line',
    color: 'from-amber-500 to-orange-500',
  },
  {
    id: 3,
    titulo: 'Nunca mostrar espacios vacíos',
    descripcion: 'Si no hay mensajes nuevos, se muestra actividad reciente. Si no hay concursos activos, se muestran los próximos. Si no hay encuestas, se muestra el historial. La cabina siempre tiene contenido.',
    icono: 'ri-inbox-line',
    color: 'from-violet-500 to-fuchsia-500',
  },
  {
    id: 4,
    titulo: 'Una acción = un clic',
    descripcion: 'Responder, destacar, bloquear, mover al aire y seleccionar ganador son acciones de un solo clic o atajo de teclado. Sin menús contextuales. Sin confirmaciones innecesarias.',
    icono: 'ri-cursor-line',
    color: 'from-sky-500 to-cyan-500',
  },
];

export const tipoMensajeMeta: Record<MensajeType, { label: string; icono: string; color: string }> = {
  mensaje: { label: 'Mensaje', icono: 'ri-chat-3-line', color: 'bg-foreground-100 text-foreground-700' },
  saludo: { label: 'Saludo', icono: 'ri-user-heart-line', color: 'bg-emerald-100 text-emerald-700' },
  cancion: { label: 'Canción', icono: 'ri-music-line', color: 'bg-violet-100 text-violet-700' },
  concurso: { label: 'Concurso', icono: 'ri-trophy-line', color: 'bg-amber-100 text-amber-700' },
  voz: { label: 'Voz', icono: 'ri-mic-line', color: 'bg-rose-100 text-rose-700' },
};

export const estadoMensajeMeta: Record<MensajeEstado, { label: string; dot: string; bg: string; text: string }> = {
  nuevo: { label: 'Nuevo', dot: 'bg-primary-500', bg: 'bg-primary-100', text: 'text-primary-700' },
  leido: { label: 'Leído', dot: 'bg-foreground-400', bg: 'bg-foreground-100', text: 'text-foreground-600' },
  respondido: { label: 'Respondido', dot: 'bg-emerald-500', bg: 'bg-emerald-100', text: 'text-emerald-700' },
  destacado: { label: 'Destacado', dot: 'bg-amber-400', bg: 'bg-amber-100', text: 'text-amber-700' },
  bloqueado: { label: 'Bloqueado', dot: 'bg-rose-500', bg: 'bg-rose-100', text: 'text-rose-700' },
  pendiente: { label: 'Pendiente', dot: 'bg-orange-500', bg: 'bg-orange-100', text: 'text-orange-700' },
};

export function filtrarMensajesPorTipo(items: MensajeCentro[], tipo: string): MensajeCentro[] {
  if (tipo === 'todo') return items.filter((m) => !m.bloqueado);
  if (tipo === 'mensajes') return items.filter((m) => m.tipo === 'mensaje' && !m.bloqueado);
  if (tipo === 'saludos') return items.filter((m) => m.tipo === 'saludo' && !m.bloqueado);
  if (tipo === 'canciones') return items.filter((m) => m.tipo === 'cancion' && !m.bloqueado);
  if (tipo === 'concursos') return items.filter((m) => m.tipo === 'concurso' && !m.bloqueado);
  if (tipo === 'bloqueados') return items.filter((m) => m.bloqueado);
  return items;
}

export function contarPorTipo(tipo: string): number {
  if (tipo === 'todo') return mensajes.filter((m) => !m.bloqueado).length;
  if (tipo === 'mensajes') return mensajes.filter((m) => m.tipo === 'mensaje' && !m.bloqueado).length;
  if (tipo === 'saludos') return mensajes.filter((m) => m.tipo === 'saludo' && !m.bloqueado).length;
  if (tipo === 'canciones') return mensajes.filter((m) => m.tipo === 'cancion' && !m.bloqueado).length;
  if (tipo === 'concursos') return mensajes.filter((m) => m.tipo === 'concurso' && !m.bloqueado).length;
  if (tipo === 'bloqueados') return mensajes.filter((m) => m.bloqueado).length;
  return 0;
}